import Vue from 'vue'
import Router from 'vue-router'

const login = () => import('@/pages/login')
const home = () => import('@/pages/home')
const index = () => import('@/pages/index')
const message = () => import('@/pages/message')
const detail = () => import('@/pages/msg/detail')
const MsgHome = () => import('@/pages/MsgHome')
const msgList = () => import('@/pages/msg/Msglist')
const auth = () => import('@/pages/auth')
const trajectory = () => import('@/pages/performance/trajectory')
const user = () => import('@/pages/performance/user')
const userinfo = () => import('@/pages/performance/userinfo')
const certificate = () => import('@/pages/performance/certificate')
const myIncome = () => import('@/pages/performance/myIncome')
const personConRate = () => import('@/pages/performance/personConRate')
const teamConRate = () => import('@/pages/performance/teamConRate')
const renewalHome = () => import('@/pages/performance/renewal/renewalHome')
const orphanAcceptance = () => import('@/pages/performance/renewal/orphanAcceptance')
const getPolicyList = () => import('@/pages/policy/getPolicyList')
const getPolicyDetails = () => import('@/pages/policy/getPolicyDetails')
const privacyPolicy = () => import('@/pages/privacyPolicy')
const notFound = () => import('@/pages/NotFound')
Vue.use(Router)

// 外勤版（pc-hasl-agent）：仅保留个人首页、个人中心、轨迹、电子执业证、收入、三要素鉴权、
// 保单查询、消息中心、资讯、资讯详情、团队继续率、孤儿单接收、个人继续率
const routes = [
  {
    path: '/',
    name: 'login',
    component: login
  },
  {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component: privacyPolicy
  },
  {
    path: '/home',
    name: 'home',
    component: home,
    redirect: '/home/index',
    children: [
      {
        path: '/home/index',
        name: 'index',
        component: index,
        meta: { title: '个人首页', auth: true }
      },
      {
        path: '/home/trajectory',
        name: 'trajectory',
        component: trajectory,
        meta: { title: '轨迹', auth: true }
      },
      {
        path: '/home/user',
        name: 'user',
        component: user,
        meta: { title: '个人中心', auth: true }
      },
      {
        path: '/home/userinfo',
        name: 'userinfo',
        component: userinfo,
        meta: { title: '个人信息', auth: true }
      },
      {
        path: '/home/certificate',
        name: 'certificate',
        component: certificate,
        meta: { title: '电子执业证', auth: true }
      },
      {
        path: '/home/myIncome',
        name: 'myIncome',
        component: myIncome,
        meta: { title: '收入', auth: true }
      },
      {
        path: '/home/auth',
        name: 'auth',
        component: auth,
        meta: { title: '三要素鉴权', auth: true }
      },
      {
        path: '/home/personConRate',
        name: 'personConRate',
        component: personConRate,
        meta: { title: '个人继续率', auth: true }
      },
      {
        path: '/teamConRate',
        name: 'teamConRate',
        component: teamConRate,
        meta: { title: '团队继续率', auth: false }
      },
      {
        path: '/getPolicyList',
        name: 'getPolicyList',
        component: getPolicyList,
        meta: { title: '保单查询', auth: true }
      },
      {
        path: '/getPolicyDetails',
        name: 'getPolicyDetails',
        component: getPolicyDetails,
        meta: { title: '保单详情', auth: true }
      },
      {
        path: '/home/message',
        name: 'message',
        component: message,
        meta: { title: '资讯', auth: true }
      },
      {
        path: '/home/detail',
        name: 'detail',
        component: detail,
        meta: { title: '资讯详情', auth: true }
      },
      {
        path: '/home/MsgHome',
        name: 'MsgHome',
        component: MsgHome,
        meta: { title: '消息中心', auth: true },
        children: [
          {
            path: '/home/msgList',
            name: 'msgList',
            component: msgList,
            meta: { title: '消息中心', auth: true }
          }
        ]
      },
      {
        path: '/renewal',
        component: renewalHome,
        redirect: '/renewal/orphanAcceptance',
        name: 'renewalHome',
        meta: { title: '续期', auth: false },
        children: [
          {
            path: 'orphanAcceptance',
            name: 'orphanAcceptance',
            component: orphanAcceptance,
            meta: { title: '孤儿单接收' }
          }
        ]
      }
    ]
  },
  {
    path: '/404',
    name: 'NotFound',
    component: notFound,
    meta: { access: 'public', title: '页面不存在' }
  },
  {
    path: '*',
    redirect: '/404'
  }
]

export default new Router({
  routes: routes,
  watch: {
    $route: function (to, from) {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js